import { CruiseType } from 'constants/cruise'
import { useQsQueryParams } from 'hooks/useQueryParams'

export default function useCruiseSelectedCabinType(cruiseType?: App.CruiseType) {
  const { cabinTypes } = useQsQueryParams<{ cabinTypes?: string }>()

  if (cabinTypes && cabinTypes.length > 1 && cabinTypes.includes('Oceanview') && cabinTypes.includes('Window')) {
    if (cruiseType && cruiseType === CruiseType.RIVER) {
      return 'Window'
    } else if (cruiseType && cruiseType === CruiseType.OCEAN) {
      return 'Oceanview'
    }

    return 'Oceanview / Window'
  }

  return cabinTypes
}
